import { z } from 'zod';

import { FlowDefinition } from 'vivaa-api';

import { ReactFlowInputParametersConfigSchema } from './parameterConfig';

export const StartBlockConfigSchema = FlowDefinition.StartBlockConfigSchema.extend({
  entityType: z
    .enum(['Patient', 'Encounter', 'Order', 'ExternalDocumentPacket', 'None'])
    .optional(),
  parameters: ReactFlowInputParametersConfigSchema.optional(),
});
export type StartBlockConfig = z.infer<typeof StartBlockConfigSchema>;
